"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.packagesReducer = void 0;
const ts_pattern_1 = require("ts-pattern");
const state_1 = require("../redux/state");
const utils_1 = require("../redux/utils");
const utils_2 = require("./utils");
const packagesReducer = (state) => (action) => (0, ts_pattern_1.match)(action)
    .with({ type: 'UPDATE_PACKAGE_PRICE' }, _action => state.update(state_1.stateKeys.packages, _state => {
    const { sku, price, discountedPrice, discountedPriceWithServicePlan } = _action.payload;
    const targetPackage = _state.value.get(sku);
    return targetPackage
        ? {
            ..._state,
            value: _state.value.set(sku, {
                ...targetPackage,
                discountedPrice,
                discountedPriceWithServicePlan,
                lastFetched: new Date().getTime(),
                price
            })
        } : _state;
}))
    .with({ type: 'SET_PACKAGES' }, _action => state.update(state_1.stateKeys.packages, _state => (0, utils_1.returnStateLoadingFalse)(_state, _action)))
    .with({ type: 'UPDATE_PACKAGES' }, _action => state.update(state_1.stateKeys.packages, _state => ({
    ..._state,
    loading: false,
    // we want to deep merge since we want to just add values to the existing packages and not do a complete overwrite
    value: (0, utils_2.updatePackages)(_state.value)(_action.payload)
})))
    .with({ type: 'SET_PACKAGES_ERROR' }, _action => state.update(state_1.stateKeys.packages, _state => ({
    ..._state,
    error: _action.payload
})))
    .with({ type: 'SET_PACKAGES_LOADING' }, _action => state.update(state_1.stateKeys.packages, _state => ({
    ..._state,
    loading: _action.payload
})))
    .exhaustive();
exports.packagesReducer = packagesReducer;
//# sourceMappingURL=reducer.js.map